import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { TooltipMessage } from '../../../Data/appMessages';

const ActionIcon = ({ iconClass, tooltipMessage, onClick, permission }) => {

    const isDisabled = !permission;
    const displayTooltip = permission ? tooltipMessage : TooltipMessage.PermissionDenied;

    return (
        <OverlayTrigger placement="top" overlay={<Tooltip>{displayTooltip}</Tooltip>} >
            <i className={`${iconClass} actions-icon ${isDisabled ? 'icon-disabled' : 'cursor-pointer'}`} onClick={!isDisabled ? onClick : null}
                style={{ opacity: isDisabled ? 0.7 : 1 }} ></i>
        </OverlayTrigger>
    );
};

export default ActionIcon;